export const baseClientEnvironment = {
  termsAndConditionsUrl: "https://www.clubity.com/index.php/datenschutz/"
};
